import { useParams } from 'next/navigation';

import {
  MENS_DEPARTMENT_URL_KEY,
  WOMENS_DEPARTMENT_URL_KEY,
} from '@/modules/categories/constants';

export function useIsMenswearOrWomenswearCategoryPage() {
  const { category } = useParams<{ category: string[] }>();

  const isTopLevelCategory = category?.length === 1;

  const isMenswearOrWomenswear = [
    MENS_DEPARTMENT_URL_KEY,
    WOMENS_DEPARTMENT_URL_KEY,
  ].includes(category?.[0]);

  return isTopLevelCategory && isMenswearOrWomenswear;
}
